module.exports = __webpack_public_path__ + "media/images/icons/icon-pound-d44b6d9968c0a4045ef5623859ab4e72.svg";